import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import MainInput from "../../Elements/MainInput/MainInput";
import ErrorMessage from "../../Elements/ErrorMessage/ErrorMessage";
import TurnstileWidget from "../../Elements/TurnstileWidget/TurnstileWidget";

import googleIcon from "../../../assets/icons/auth/forms/google.svg";
import appleIcon from "../../../assets/icons/auth/forms/apple.svg";
import envelopeIcon from "../../../assets/icons/auth/forms/envelope.png";
import envelopePrimaryIcon from "../../../assets/icons/auth/forms/envelope-primary.png";

import "../CheckoutPanel/CheckoutPanel.css";

const AuthPanel = ({
  email,
  errorMessage,
  onEmailChange,
  onErrorClose,
  onLoginClick,
  turnstileSiteKey,
  showTurnstile,
  onTurnstileVerify,
  onTurnstileExpire,
  onTurnstileError,
}) => {
  const { t } = useTranslation();

  return (
    <div className="checkout__right">
      <h3 className="checkout__title">{t("cart.signUpLogin")}</h3>

      <p className="auth__subtitle">{t("cart.esimSentToEmail")}</p>

      <form className="auth-form" onSubmit={(e) => e.preventDefault()}>
        <div className="auth-social">
          <Link to="/sign-in" className="social-btn social-btn--email" title="Log in with email and password">
            <img src={envelopePrimaryIcon} alt="Email login" className="social-btn__icon" />
            {t("auth.email")}
          </Link>

          <button type="button" className="social-btn social-btn--google" onClick={onLoginClick}>
            <img src={googleIcon} alt="" className="social-btn__icon" />
            Google
          </button>

          <button type="button" className="social-btn social-btn--apple" onClick={onLoginClick}>
            <img src={appleIcon} alt="" className="social-btn__icon social-btn__icon--apple" />
            Apple
          </button>
        </div>

        <div className="auth-divider" role="separator" aria-label="Or continue with">
          <span>{t("cart.orContinueAsGuest")}</span>
        </div>

        <div className="auth-fields">
          <label className="auth-field">
            <div className="input-with-icon checkout-input-with-icon">
              <img src={envelopeIcon} className="input-icon" alt="Email icon" />

              <MainInput
                placeholder={t("auth.email")}
                type="email"
                name="email"
                value={email}
                onChange={onEmailChange}
                required
              />
            </div>
          </label>

          {showTurnstile && (
            <div className="turnstile-wrapper">
              <TurnstileWidget
                siteKey={turnstileSiteKey}
                onVerify={onTurnstileVerify}
                onExpire={onTurnstileExpire}
                onError={onTurnstileError}
              />
            </div>
          )}

          <ErrorMessage message={errorMessage} onClose={onErrorClose} />
        </div>
      </form>
    </div>
  );
};

export default AuthPanel;
